// import React from "react";
// import ReactDOM from "react-dom/client";
// import reportWebVitals from "./reportWebVitals";
// import AppRoutes from "./routes/route";
// import "./App.scss";

// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <AppRoutes />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./routes/route";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { ToastContainer } from "react-toastify";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { isElectronKiosk } from "./utils/kioskRuntime";
import { disablePinchZoom } from "./utils/disablePinchZoom";
import KioskErrorBoundary from "./components/KioskErrorBoundary";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import "./Responsive.scss";
import "./Custom.scss";

disablePinchZoom();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);


root.render(
  <React.StrictMode>
    <KioskErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="dark"
          />
        </PersistGate>
      </Provider>
    </KioskErrorBoundary>
  </React.StrictMode>
);

if (isElectronKiosk()) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}

